import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store';
// import './registerServiceWorker'
import { simbPlug } from '@/plugins/simboleum.js';


Vue.use(simbPlug);
import './plugins/ant-design-vue.js';
import { httpSetup } from './http/httpSetup';
httpSetup();
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
